var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('v-zoomer',{staticStyle:{"width":"100%","height":"100%"}},[_c('img',{staticStyle:{"object-fit":"contain","width":"100%","height":"100%","cursor":"zoom-in"},attrs:{"src":_vm.responsiveImagesLarge}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }